import { useSendTestNotificationToSelfMutation } from 'generated/graphql';
import React from 'react';

export function useSendTestNotificationToSelf() {
  const [
    fnMutate,
    tuple
  ] = useSendTestNotificationToSelfMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async () => {
      await fnMutate({
        variables: {
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
